import { useAuth0 } from "@auth0/auth0-react";

interface LogoutButtonProps {
  className?: string;
}

function LogoutButton({ className = "" }: LogoutButtonProps) {
  const { logout, isLoading } = useAuth0();

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <button
      onClick={handleLogout}
      disabled={isLoading}
      className={`btn-secondary ${className}`}
    >
      {isLoading ? "Loading..." : "Sign Out"}
    </button>
  );
}

export default LogoutButton;

